import { useEffect } from "react";
import { Card, CardBody, Button, CardHeader, Col, Row, Label, Form, FormGroup, CustomInput } from "reactstrap";
import { useState } from "react";
import { useAuthState } from "../../../../../context";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { hideMenuTypeTabs, hideSchoolDrowdown, showMenuTypeTabs, showSchoolDrowdown, showMenuTypeBar, hideMenuTypeBar } from "../../../../../actions/menuTypeAction";
import { useMenuTypeDispatch } from "../../../../../context/MenuTypeContext";
import { toast } from "react-toastify";
import { saveInventoySiteData, updateSiteList, getInventorySiteListDataByID } from "../../../../../actions/inventorySiteActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MessageConst } from "../../../../../helpers/messageConst";

const AddNewInventorySite = (props) => {
    const location = useLocation();
    const dispatch = useMenuTypeDispatch();
    const { otherInfo } = useAuthState();
    const { schools, isEdit, selectedData, inventorySite } = location?.state || {};
    const [loading, setLoading] = useState(false);
    const [checkedItems, setCheckedItems] = useState({});
    const [siteName, setSiteName] = useState('');
    const [siteData, setSiteData] = useState({});
    const [disabledItems, setDisabledItems] = useState({});
    const [otherSelectedSchools, setOtherSelectedSchools] = useState({});

    console.log("inventorySiteList:::::::", inventorySite)
    console.log("schools::::", schools);
    useEffect(() => {
        hideMenuTypeBar(dispatch);
        return async () => {
            await showMenuTypeBar(dispatch);
        }
    }, []);
    useEffect(() => {
        if (isEdit) {
            getInventorySiteByID(selectedData);
        } else {
            setDisabledSchools(inventorySite);
        }
    }, [])

    const setDisabledSchools = (inventorySite, existingSchoolIds = []) => {
        let _disabledItems = {}
        let _checkedItems = {};
        console.log("checkedItems::::", checkedItems);
        inventorySite.map(inventoryItem => {
            //console.log("inventoryItem:::",inventoryItem);
            inventoryItem.schools.map(school => {
                console.log(school);
                if (!existingSchoolIds.includes(school.schoolId)) {
                    _disabledItems[school.schoolId] = true
                    _checkedItems[school.schoolId] = true
                }
            })
        });
        setDisabledItems(_disabledItems);
        setCheckedItems(prevState => ({
            ...prevState, // Spread the previous state
            ..._checkedItems // Add or update the new value
        }));
        setOtherSelectedSchools(_checkedItems);
    }

    const getInventorySiteByID = async (id) => {
        try {
            setLoading(true);
            const res = await getInventorySiteListDataByID({ siteId: id, catererId: otherInfo.catererId });
            console.log("getInventorySiteListDataByID::::::", res);
            if (res.success) {
                console.log("response:::::::::", res.data.data);
                let _siteData = res.data.data || {};
                let _checkedItems = {};
                let _existingSchoolIds = [];
                _siteData.schools.map(school => {
                    console.log(school);
                    _checkedItems[school.schoolId] = true
                    _existingSchoolIds.push(school.schoolId);
                });
                setSiteData(_siteData);
                setSiteName(_siteData.siteName);
                setCheckedItems(_checkedItems);
                setDisabledSchools(inventorySite, _existingSchoolIds);
            }
            setLoading(false);
        } catch (error) {
            console.log(error)
        }
    }

    const handleChange = (e) => {
        setSiteName(e.target.value);
        console.log("siteName:::::::", e.target.value);
    };

    const saveInventoySite = async (siteId) => {
        setLoading(true);
        let schoolList = [];
        let selectedSchools = Object.fromEntries(
            Object.entries(checkedItems).filter(([key]) => !Object.keys(otherSelectedSchools).includes(key))
        );
        console.log("selectedSchools:::", selectedSchools);
        if (isEdit) {
            schoolList = Object.keys(selectedSchools).filter(key => selectedSchools[key]).map(key => ({ "schoolId": parseInt(key) }));
            console.log("schoolLIst11:::", schoolList);
        } else {
            schoolList = Object.entries(selectedSchools)
                .filter(([key, value]) => value === true)
                .map(([key, _]) => parseInt(key));
        }

        console.log("selectedSchools:::", schoolList);
        const reqBody = {
            siteName: siteName,
            schools: schoolList
        };
        if ((siteName || "").length <= 0) {
            toast.error(MessageConst.Inv_Site_Validate_Site_Req);
            return true;
        }
        if ((schoolList || "").length <= 0) {
            toast.error(MessageConst.Inv_Site_Validate_School_Req_Select);
            return true;
        }
        if (isEdit) {
            reqBody["siteId"] = siteData.siteId;
            console.log("reqBody::::", reqBody);
            const resp = await updateSiteList(reqBody, otherInfo.catererId, siteData.siteId);
            console.log(resp);
            if (!resp.error) {
                toast.success(MessageConst.Inv_Site_Update);
                props.history.goBack();
            } else {
                toast.error(resp.errorMessage);
            }

        } else {
            console.log("reqBody::::", reqBody);
            const resp = await saveInventoySiteData(otherInfo.catererId, reqBody);
            console.log(resp)
            if (resp.success) {
                toast.success(MessageConst.Inv_Site_Create);
                props.history.push({ pathname: `/settings/inventorySiteList` });
            } else {
                toast.error(resp.errorMessage);
            }
        }
    }
    const onChange = (id) => {
        console.log("callling to id:::", id);
        console.log("checkedItems:::", checkedItems);
        setCheckedItems({
            ...checkedItems,
            [id]: !checkedItems[id] // Toggle checkbox state
        });
    };

    return (<>
        <Card className='p-4'>
            <CardHeader className='p-2 bg-light'>
                <Row className='justify-content-between'>
                    <Col><h5>{isEdit ? "Edit Inventory Site" : "Add New Inventory Site"}</h5></Col>
                    <Col xs={'auto'}>
                        <Button color="falcon-primary" size="sm" onClick={(e) => { props.history.push({ pathname: `/settings/inventorySiteList` }); }}>
                            <FontAwesomeIcon icon="arrow-left" transform="shrink-3" className="mr-1" />
                            Back
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody className='p-2'>
                <Row>
                    <Col>
                        <form >
                            <Row>
                                <Col >
                                    <Row>
                                        <Col>
                                            <FormGroup row>
                                                <Label for="name" md={2}  >
                                                    Inventory Site Name :
                                                </Label>
                                                <Col sm={5}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={siteName}
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="name" md={2}  >
                                                    Select School :
                                                </Label>

                                                {
                                                    <Row className='mt-4 mb-3'>
                                                        {
                                                            schools.map((item, index) => (
                                                                <Col sm={10} className="mt-2">
                                                                    <FormGroup className="custom-control custom-checkbox">
                                                                        <div key={item.schoolId} style={{ margin: '-10px 8px' }}>
                                                                            <input
                                                                                className="custom-control-input"
                                                                                type="checkbox"
                                                                                id={item.schoolId}
                                                                                name={item.schoolName}
                                                                                value={item.schoolId}
                                                                                checked={checkedItems[item.schoolId] || false}
                                                                                disabled={disabledItems[item.schoolId] || false}
                                                                                onChange={() => onChange(item.schoolId)}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor={item.schoolId}>{item.schoolName}</label>
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                            ))

                                                        }
                                                    </Row>
                                                }
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className='flex-between-center mt-3'>
                                        <Col xs={'auto'}>
                                            <Button color="primary mr-3" onClick={() => { props.history.push({ pathname: `/settings/inventorySiteList` }); }}>Cancel</Button>
                                        </Col>
                                        <Col xs={'auto'}>
                                            <Button color="primary mr-3" onClick={() => { saveInventoySite() }} >Save</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </form>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </>);
}
export default AddNewInventorySite;